import type { TemplateOnlyComponent as TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import SettingsMyHotelFormHotelDetails from 'lumen/components/settings/my-hotel/form-hotel-details';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type HotelSettingsMyHotelHotelDetailsController from 'lumen/controllers/hotel/settings/my-hotel/hotel-details';

interface HotelSettingsMyHotelHotelDetailsSignature {
  Args: {
    controller: HotelSettingsMyHotelHotelDetailsController;
  };
}

const HotelSettingsMyHotelHotelDetailsTemplate = <template>
  <SettingsPageTemplate
    @description={{t "settings.my_hotel.hotel_details.description"}}
    @title={{t "settings.my_hotel.hotel_details.title"}}
    @type="container"
  >
    <SettingsMyHotelFormHotelDetails @model={{@controller.model}} />
  </SettingsPageTemplate>
</template> satisfies TOC<HotelSettingsMyHotelHotelDetailsSignature>;

export default HotelSettingsMyHotelHotelDetailsTemplate;
